module.exports = __webpack_public_path__ + "static/media/rotate.aaa7d450.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/EditPooch/rotate.png
// module id = 604
// module chunks = 0